//import $ from 'jquery';
import Menu from  './menu-component';
// window.$ = window.jQuery = $;
var menuClasses = [];
// /**
//  * Create a slick carousel from .collection-whisky-listing container and .collection-slide as slides. .carousel-nav-button--left as left arrow button. carousel-nav-button--right as right arrow button. Slide the carousel one at a time. Make the carousel loop all the items.
//  */
var country_code;
$(document).ready(function () {
	var url = window.location.href;
	var parts = url.split("/");
	country_code = $("#country_code").val();
	
	// thank-you slug is now a cms page for braze
	// if(parts[parts.length - 1] == "thank-you") {
	// 	window.location.href = "/en-gb/";
	// }

	$("#dob-day").on('keyup', function(){
        if($(this).val().length == 2){
            $("#dob-month").focus();
        }
    });
    
    $("#dob-month").on('keyup', function(){
        if($(this).val().length == 2){
            $("#dob-year").focus();
        }
    });
    
	if ($("#country_code").val() == 'en-gb') {
		$("#dob").attr('Placeholder', "Date of birth format (dd/mm/yyyy)");
	} else if ($("#country_code").val() == 'en-us') {
		$("#dob").attr('Placeholder', "Date of birth format (mm/dd/yyyy)");
	}
	
	if ($("#country_code").val() == 'en-gb') {
		$("#dob").attr('Placeholder', "Date of birth format (dd/mm/yyyy)");
	} else if ($("#country_code").val() == 'en-us') {
		$("#dob").attr('Placeholder', "Date of birth format (mm/dd/yyyy)");
	}
	if($(".container--form-api").length) {
	    
	    $("#submit-btn").on('click', function() {
	    	var valid = true;
	    	
	    	if (!$("#firstname").val()) {
	    		valid = false;
	    		$("#firstname").addClass("error");
	    		
	    	} else {
	    		$("#firstname").removeClass("error");	
	    	}
	    	
	    	if (!$("#lastname").val()) {
	    		valid = false;
	    		$("#lastname").addClass("error");
	    		
	    	} else {
	    		$("#lastname").removeClass("error");	
	    	}
	    	
	    	if (!isValidDate($("#dob-year").val(), $("#dob-month").val(), $("#dob-day").val()) ) {
				valid = false;
				$("#dob-day").addClass("error");
				$("#dob-month").addClass("error");
				$("#dob-year").addClass("error");
			} else {
				$("#dob-day").removeClass("error");	
				$("#dob-month").removeClass("error");	
				$("#dob-year").removeClass("error");	
			}
			
	    	if (country_code && country_code == "en-us") {
		    	if (!$("#postcode").val()) {
		    		valid = false;
		    		$("#postcode").addClass("error");
		    		
		    	} else {
		    		$("#postcode").removeClass("error");	
		    	}
	    	}
	    	
	    	if ($("#email").val() == "" || !isEmail($("#email").val())) {
	    		valid = false;
	    		$("#email").addClass("error");
	    	} else {
	    		$("#email").removeClass("error");	
	    	}
	    	
	    	if (!$("#agree").is(':checked')) {
	    		valid = false;
	    		$("#agree").addClass("error");
	    		
	    	} else {
	    		$("#agree").removeClass("error");	
	    	}
	    	
	    	if (!$("#chk_analytics").is(':checked')) {
	    		valid = false;
	    		$("#chk_analytics").addClass("error");
	    		
	    	} else {
	    		$("#chk_analytics").removeClass("error");	
	    	}
	    	
	    	if (!valid) {
	    		return false;
	    	}
	    	
	    	var form = $(this).parents('form');
	    	
	    	grecaptcha.ready(function() {
                // do request for recaptcha token
                // response is promise with passed token
                grecaptcha.execute('6Lfpx6whAAAAAJvpYIe2X4twQ6zHhfF_ZPxprfQr', {action: 'register_form'}).then(function(token) {
                        //success  
                        var token = $("#token").val(token);
                        var formAction = form.attr('action');
	        			var formData = form.serialize();
				        
				        $.ajax({
			                type: "POST",
			                // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
			                url: formAction,
			                data: formData,
			                dataType: "json",
			                success: function(response) {
								if (response.status == "Subscribed" || response.status == "ContactAdded" || response.status == "ContactChallenged") {
			                    	var country_code = $("#country_code").val();
			                    	var thank_you = "/thank-you";
			                    	
			                    	if (country_code != "") {
			                    		thank_you = "/" + country_code + thank_you;
			                    	}
			                    	
			                    	$(".container--form-api form").fadeOut('fast', function() {
			                    		$("#thank_you_message").fadeIn();
			                    		window.history.pushState({},"", thank_you);
			                    	});
			                    } else {
			                    	// Handle error responses
								    var errorMessage = '';
								    
								    if (response.message) {
								        errorMessage = response.message;
								    }
								    
								    // If there are specific errors, display them as bullet points
								    if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
								        errorMessage += '<ul style="margin-top: 10px; padding-left: 20px;">';
								        response.errors.forEach(function(error) {
								            errorMessage += '<li>' + error + '</li>';
								        });
								        errorMessage += '</ul>';
								    }
								    
								    // Fallback error message if nothing is provided
								    if (!errorMessage) {
								        errorMessage = "An error has occurred. Please try again.";
								    }
								    
			                        $(".message.row").html(errorMessage).fadeIn();
			                        // $(".message.row").html("An error has occured. Please try again").fadeIn();
			                    }
			                },
			                error: function (jqXHR, exception) {
							    $(".message.row").html("An error has occured. Please try again").fadeIn();
							}
			            }).done(function (data) {
			                console.log('FORM SUBMITTED');
			            });
                });;
            });
	    });
	    
	     $("#submit-btn-in").on('click', function() {
	    	var valid = true;
	    	
	    	if (!$("#firstname").val()) {
	    		valid = false;
	    		$("#firstname").addClass("error");
	    		
	    	} else {
	    		$("#firstname").removeClass("error");	
	    	}
	    	
	    	if (!$("#lastname").val()) {
	    		valid = false;
	    		$("#lastname").addClass("error");
	    		
	    	} else {
	    		$("#lastname").removeClass("error");	
	    	}
	    	
	    	if ($("#email").val() == "" || !isEmail($("#email").val())) {
	    		valid = false;
	    		$("#email").addClass("error");
	    	} else {
	    		$("#email").removeClass("error");	
	    	}
	    	
	    	// if (!$("#agree").is(':checked')) {
	    	// 	valid = false;
	    	// 	$("#agree").addClass("error");
	    		
	    	// } else {
	    	// 	$("#agree").removeClass("error");	
	    	// }
	    	
	    	if (!valid) {
	    		return false;
	    	}
	    	
	    	var form = $(this).parents('form');
	    	
	    	grecaptcha.ready(function() {
                // do request for recaptcha token
                // response is promise with passed token
                grecaptcha.execute('6Lfpx6whAAAAAJvpYIe2X4twQ6zHhfF_ZPxprfQr', {action: 'register_form'}).then(function(token) {
                        //success  
                        var token = $("#token").val(token);
                        var formAction = form.attr('action');
	        			var formData = form.serialize();
				        
				        $.ajax({
			                type: "POST",
			                // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
			                url: formAction,
			                data: formData,
			                dataType: "json",
			                success: function(response) {
			                	
			                	if (response.success) {
			                		var country_code = $("#country_code").val();
			                    	var thank_you = "/thank-you";
			                    	
			                    	if (country_code != "") {
			                    		thank_you = "/" + country_code + thank_you;
			                    	}
			                    	
			                    	$(".container--form-api form").fadeOut('fast', function() {
			                    		$("#thank_you_message").fadeIn();
			                    		window.history.pushState({},"", thank_you);
			                    	});
			                    } else {
			                        var errorMessage = '';
								    
								    if (response.message) {
								        errorMessage = response.message;
								    }
								    
								    // If there are specific errors, display them as bullet points
								    if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
								        errorMessage += '<ul style="margin-top: 10px; padding-left: 20px;">';
								        response.errors.forEach(function(error) {
								            errorMessage += '<li>' + error + '</li>';
								        });
								        errorMessage += '</ul>';
								    }
								    
								    // Fallback error message if nothing is provided
								    if (!errorMessage) {
								        errorMessage = "An error has occurred. Please try again.";
								    }
								    
			                        $(".message.row").html(errorMessage).fadeIn();
			                        // $(".message.row").html("An error has occured. Please try again").fadeIn();
			                    }
			                },
			                error: function (jqXHR, exception) {
							    $(".message.row").html("An error has occured. Please try again").fadeIn();
							}
			            }).done(function (data) {
			                console.log('FORM SUBMITTED');
			            });
                });;
            });
	    });
	    
	    $(".floater").on('click', function(e) {
	        e.preventDefault();
	        $(".container--form-api")
	            .css("z-index", 10)  // Set the left to its calculated position
                .animate({"right":"0px"}, 500);
                
                
             if ($(this).hasClass("floater-menu")) {
             	var menu_toggle = $(".menu-toggle");
             	
             	$.each(menu_toggle, function(index) {
             		if ($(this).attr("id") != "menu-toggle") {
             			$(this).trigger("click");		
             		} 
             	});
             	
             }
                
            return false;
	    });
	    
	    $(".close-button-link").on('click', function(e) {
	        e.preventDefault();
	        $(".container--form-api")
                .animate({"right":"-100vw"}, 500, function() {
                    $(this).css("z-index", -100)  // Set the left to its calculated position    
                });
            $(".message.row").hide();
            return false;
	    });
	}
});

var submenu_list = [];
var bread_crumb = null;
function resetMenu()
{
	bread_crumb = $(".main--navigation").find(".breadcrumb").children('ol');
    $(".in-from-right").removeClass("in-from-right");
    $(".out-to-left").removeClass("out-to-left");
    $(".second-column").removeClass("second-column");
    $(".first-column").removeClass("first-column");
    $(".visible").removeClass("visible");
    $(".main--navigation .menu").addClass("hidden").removeAttr('style');
    $(".menu-item").css("opacity", 0).removeAttr("style");
    $(".menu--top-level").addClass("first-column").removeClass("hidden");
    
    $(".main--navigation").find('.blur-link').removeClass("blur-link");
    
    submenu_list = [];
    submenu_list.push({
        'id': 0,
        'text': 'Home'
    });
    bread_crumb.html("");
}

function isValidDate(year, month, day) {
    month = Number(month) - 1; //bloody 0-indexed month
    var d = new Date(year, month, day);
    if (d.getFullYear() == year && d.getMonth() == month && d.getDate() == day) {
        return true;
    }
    
    return false;
}

// function validateDate(date)
// {
// 	var country_code = $("#country_code").val();
// 	var d_reg = "";
	
// 	if (country_code == "en-gb") {
// 		d_reg = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/([12][0-9]{3})$/;
		
// 		if (d_reg.test(date)) {
// 			var month = $("#dob-month").val();
// 			var day = $("#dob-day").val();
// 			var year = $("#dob-year").val();
		
// 			if (Date.parse(month + "/" + day + "/" + year)) {
// 				return true;
// 			}
			
// 			return false;
// 		}
		
// 		return false;
// 	} else if(country_code == "en-us") {
// 		d_reg = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/([12][0-9]{3})$/;
		
// 		if (d_reg.test(date)) {
// 			alert("EN_US reg" + date);
// 			var month = $("#dob-month").val();
// 			var day = $("#dob-day").val();
// 			var year = $("#dob-year").val();
		
// 			if (Date.parse(month + "/" + day + "/" + year)) {
// 				alert("EN_US parse" + date);
// 				return true;
// 			}
			
// 			return false;
// 		}
		
// 		return false;
// 	}
	
// 	return false;
// }

function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

var $document = $(document);
var displayingToggle = false;
var windowHeight = $( window ).height();
var toggleTriggerHeight = (windowHeight - (windowHeight/2));
var isMobile = (window.matchMedia("(max-width: 767px)").matches) ? true : false;

if (!isMobile) {
	toggleTriggerHeight = (windowHeight + (windowHeight/6));
}
if ($(".container--form-api").length != 0) {
	// $document.scroll(function() {
	//     if ($document.scrollTop() >= toggleTriggerHeight) {
	//     	if (!displayingToggle)  {
	//     		$(".floater-container").fadeIn('fast');
	//             displayingToggle = true;
	//     	}
	        
	//     } else {
	//         if (displayingToggle) {
	// 	        $(".floater-container").fadeOut('fast');
	// 	        displayingToggle = false;
	//         }
	        
	//     }
	// });
}


$(document).ready(function() {
 	if ($(".gf-form-register").length) {
 		if (country_code == "en-us") {
 			$(".field--month-text").on('keyup', function(){
		        if($(this).val().length == 2){
		        	$(this).parents(".form--field").find(".field--day-text").focus();
		        }
		    });
		    
		    $(".field--day-text").on('keyup', function(){
		        if($(this).val().length == 2){
		        	$(this).parents(".form--field").find(".field--year-text").focus();
		        }
		    });
 		} else if (country_code == "en-gb") {
 			$(".field--day-text").on('keyup', function(){
		        if($(this).val().length == 2){
		        	$(this).parents(".form--field").find(".field--month-text").focus();
		        }
		    });
		    
		    $(".field--month-text").on('keyup', function(){
		        if($(this).val().length == 2){
		        	$(this).parents(".form--field").find(".field--year-text").focus();
		        }
		    });
 		} else {
 			$(".field--month-text").on('keyup', function(){
		        if($(this).val().length == 2){
		        	$(this).parents(".form--field").find(".field--day-text").focus();
		        }
		    });
		    
		    $(".field--day-text").on('keyup', function(){
		        if($(this).val().length == 2){
		        	$(this).parents(".form--field").find(".field--year-text").focus();
		        }
		    });
 			
 		}
 		// This one will trigger the modal or any target form. Just add gf-form-register and teh data-target is the ID of the target form
		$(".gf-form-register").on('click', function(evt) {
			evt.preventDefault();
			var target_id = $(this).data('target');
			
			$("#" + target_id).addClass("show");
			return false;
		});
		
		$(".form--close-button").on('click', function(evt) {
			evt.preventDefault();
			var parent_div = $(this).parents(".form--submit");
			var target_id = parent_div.attr('id');
			$("#" + target_id).removeClass("show");
			$("#" + target_id + " .failed_message").addClass("hidden");
			return false;
		});
		
		
 	}
 	
 	if ($(".gf-form-btn").length) {
 		if (country_code == "en-gb") {
 			$(".field--month-text").attr("tabindex", 6);
 			$(".field--day-text").attr("tabindex", 5);
 			$(".field--year-text").attr("tabindex", 7);
 		} else if(country_code == "en-us") {
 			$(".field--month-text").attr("tabindex", 5);
 			$(".field--day-text").attr("tabindex", 6);
 			$(".field--year-text").attr("tabindex", 7);
 		}
 		
 		
 		// $("#country-select-form_submit_register_interest-field").attr("disabled", "disabled");
 		$("#country-select-form_submit_register_interest-field > option").each(function() {
		    // alert(this.text + ' ' + this.value);
		    
		    if (country_code != "") {
			    if ($(this).attr("selected") === undefined) {
			    	$(this).remove();
			    }
		    } else {
		    	// if ($(this).attr("value") == "XX") {
			    // 	$(this).remove();
			    // }
		    }
		});
	 	$(".gf-form-btn").on('click', function() {
	 		
			var form = $(this).parents('form');
	    	var container_id = form.parents(".form--submit").attr("id");
			var valid = true;
	    	
	    	if ($("#name-" + container_id + "-field").length) {
		    	if (!$("#name-" + container_id + "-field").val()) {
		    		valid = false;
		    		$("#name-" + container_id + "-field").addClass("error");
		    		
		    	} else {
		    		$("#name-" + container_id + "-field").removeClass("error");	
		    	}	
	    	}
	    	
	    	if ($("#first-name-" + container_id + "-field").length) {
		    	if (!$("#first-name-" + container_id + "-field").val()) {
		    		valid = false;
		    		$("#first-name-" + container_id + "-field").addClass("error");
		    		
		    	} else {
		    		$("#first-name-" + container_id + "-field").removeClass("error");	
		    	}	
	    	}
	    	
	    	if ($("#last-name-" + container_id + "-field").length) {
		    	if (!$("#last-name-" + container_id + "-field").val()) {
		    		valid = false;
		    		$("#last-name-" + container_id + "-field").addClass("error");
		    		
		    	} else {
		    		$("#last-name-" + container_id + "-field").removeClass("error");	
		    	}	
	    	}
	    	
	    	if ($("#phone-" + container_id + "-field").length) {
		    	if (!$("#phone-" + container_id + "-field").val()) {
		    		valid = false;
		    		$("#phone-" + container_id + "-field").addClass("error");
		    		
		    	} else {
		    		$("#phone-" + container_id + "-field").removeClass("error");	
		    	}	
	    	}
	    	
	    	if ($("#zipcode-" + container_id + "-field").length) {
		    	if (!$("#zipcode-" + container_id + "-field").val()) {
		    		valid = false;
		    		$("#zipcode-" + container_id + "-field").addClass("error");
		    		
		    	} else {
		    		$("#zipcode-" + container_id + "-field").removeClass("error");	
		    	}	
	    	}
	    	
	    	if ($("#address-" + container_id + "-field").length) {
		    	if (!$("#address-" + container_id + "-field").val()) {
		    		valid = false;
		    		$("#address-" + container_id + "-field").addClass("error");
		    		
		    	} else {
		    		$("#address-" + container_id + "-field").removeClass("error");	
		    	}	
	    	}
	    	
	    	if ($("#year-" + container_id + "-field").length && $("#month-" + container_id + "-field").length && $("#day-" + container_id + "-field").length) {
		    	if (!isValidDate($("#year-" + container_id + "-field").val(), $("#month-" + container_id + "-field").val(), $("#day-" + container_id + "-field").val()) ) {
					valid = false;
					$("#day-" + container_id + "-field").addClass("error");
					$("#month-" + container_id + "-field").addClass("error");
					$("#year-" + container_id + "-field").addClass("error");
				} else {
					$("#day-" + container_id + "-field").removeClass("error");	
					$("#month-" + container_id + "-field").removeClass("error");	
					$("#year-" + container_id + "-field").removeClass("error");	
				}
	    	}
	    	
	    	if ($("#email-" + container_id + "-field").length) {
		    	if ($("#email-" + container_id + "-field").val() == "" || !isEmail($("#email-" + container_id + "-field").val())) {
		    		valid = false;
		    		$("#email-" + container_id + "-field").addClass("error");
		    	} else {
		    		$("#email-" + container_id + "-field").removeClass("error");	
		    	}
	    	}
	    	
	    	if ($("#country-" + container_id + "-field").length) {
		    	if (!$("#country-" + container_id + "-field select").val()) {
		    		valid = false;
		    		$("#country-" + container_id + "-field select").addClass("error");
		    		
		    	} else {
		    		$("#country-" + container_id + "-field select").removeClass("error");	
		    	}
	    	}
	    	
	    	if ($("#state-" + container_id + "-field").length) {
		    	if (!$("#state-" + container_id + "-field select").val()) {
		    		valid = false;
		    		$("#state-" + container_id + "-field select").parents(".field--input").addClass("error");
		    		
		    	} else {
		    		$("#state-" + container_id + "-field select").parents(".field--input").removeClass("error");	
		    	}
	    	}
	    	
	    	if ($("#agree-" + container_id + "-field").length) {
	    		if ($("#agree-" + container_id + "-field").data('required') == true) {
	    			if (!$("#agree-" + container_id + "-field").is(':checked')) {
			    		valid = false;
			    		$("#agree-" + container_id + "-field").addClass("error");
			    		
			    	} else {
			    		$("#agree-" + container_id + "-field").removeClass("error");	
			    	}	
	    		}
	    	}
	    	
	    	if ($("#optin-" + container_id + "-field").length) {
	    		if ($("#optin-" + container_id + "-field").data('required') == true) {
	    			if (!$("#optin-" + container_id + "-field").is(':checked')) {
			    		valid = false;
			    		$("#optin-" + container_id + "-field").addClass("error");
			    		
			    	} else {
			    		$("#optin-" + container_id + "-field").removeClass("error");	
			    	}	
	    		}
	    	}
	    	
	    	if ($("#optin-second-" + container_id + "-field").length) {
	    		if ($("#optin-second-" + container_id + "-field").data('required') == true) {
	    			if (!$("#optin-second-" + container_id + "-field").is(':checked')) {
			    		valid = false;
			    		$("#optin-second-" + container_id + "-field").addClass("error");
			    		
			    	} else {
			    		$("#optin-second-" + container_id + "-field").removeClass("error");	
			    	}	
	    		}
	    	}
	    	
	    	
	    	if (!valid) {
	    		console.log("An error occured");
	    		return false;
	    	}
	    	
			grecaptcha.ready(function() {
	            // do request for recaptcha token
	            // response is promise with passed token
	            grecaptcha.execute('6Lfpx6whAAAAAJvpYIe2X4twQ6zHhfF_ZPxprfQr', {action: 'register_form'}).then(function(token) {
	                //success  
	                var token = $("#" + container_id + "_token").val(token);
	                var formAction = form.attr('action');
	    			var formData = form.serialize();
	    			
			        $.ajax({
		                type: "POST",
		                // headers: {'Content-Type': 'application/x-www-form-urlencoded'},
		                url: formAction,
		                data: formData,
		                dataType: "json",
		                success: function(response) {
		                	console.log(response);
							if (response.status == "Subscribed" || response.status == "ContactAdded" || response.status == "ContactChallenged") {
								
								if ($("#redirect_url").length && $("#redirect_url").val() != "") {
									window.location.href = $("#redirect_url").val();
								} else {
			                    	$("#" + container_id + " .form--field").remove();
			                    	$("#" + container_id + " .content").addClass("hidden");
			                    	$("#content-" + container_id + "-field").addClass("hidden");
			                    	$("#" + container_id + " .success_message").removeClass("hidden");
								}
		                    } else {
		                    	$("#" + container_id + " .success_message").addClass("hidden");
		                    	$("#" + container_id + " .failed_message").removeClass("hidden");
		                    }
		                    
		                    if ($(".grand-chateau")) {
		                    	var $target = $(".scroll-target-element");
		                    	
		                    	if ($target.length) {
			                    	$([document.documentElement, document.body]).animate({
								        scrollTop: $target.offset().top
								    }, 1000);	
		                    	} else {
			                    	$([document.documentElement, document.body]).animate({
								        scrollTop: $('#'+ container_id).offset().top
								    }, 1000);	
		                    	}
		                    } else {
			                    $([document.documentElement, document.body]).animate({
							        scrollTop: $('#'+ container_id).offset().top
							    }, 1000);
		                    }
		                },
		                error: function (jqXHR, exception) {
						    $(".message.row").html("An error has occured. Please try again").fadeIn();
						}
		            }).done(function (data) {
		                console.log('FORM SUBMITTED');
		            });
	            });;
	        })
		});
 	}
});